export default "__VITE_ASSET__BDjMZb7W__"